import ComponentManager from '../shared/component-manager';

import AvatarBuilder from './components/avatar-builder/avatar-builder';
import AvatarBuilderError from './components/avatar-builder/avatar-builder-error';
import AvatarBuilderOptionsNavigation from './components/avatar-builder/avatar-builder-options-navigation';

class AvatarBuilderComponentManager extends ComponentManager {
  initializeComponents() {
    const avatarBuilderError = AvatarBuilderError.initialize(
      '.menteeAvatarBuilderModal-error'
    );
    AvatarBuilderOptionsNavigation.initialize(
      '.menteeAvatarBuilderModal-body-category-nav-text'
    );

    AvatarBuilder.initialize('.menteeAvatarBuilderModal', {
      avatarBuilderError: avatarBuilderError[0],
    });
  }
}

export const initialize = () => {
  jQuery(() => {
    new AvatarBuilderComponentManager([
      AvatarBuilder,
      AvatarBuilderError,
      AvatarBuilderOptionsNavigation,
    ]);
  });
};
